/* This is a mst-gql generated file, don't modify it manually */
/* eslint-disable */
/* tslint:disable */

import { types } from "mobx-state-tree"
import { QueryBuilder } from "mst-gql"
import { ModelBase } from "./ModelBase"
import { ErrorDetailsDtoModel, ErrorDetailsDtoModelType } from "./ErrorDetailsDtoModel"
import { ErrorDetailsDtoModelSelector } from "./ErrorDetailsDtoModel.base"
import { RootStoreType } from "./index"


/**
 * ErrorParamsDtoBase
 * auto generated base class for the model ErrorParamsDtoModel.
 */
export const ErrorParamsDtoModelBase = ModelBase
  .named('ErrorParamsDto')
  .props({
    __typename: types.optional(types.literal("ErrorParamsDto"), "ErrorParamsDto"),
    code: types.union(types.undefined, types.null, types.string),
    error: types.union(types.undefined, types.null, types.string),
    details: types.union(types.undefined, types.null, types.late((): any => ErrorDetailsDtoModel)),
  })
  .views(self => ({
    get store() {
      return self.__getStore<RootStoreType>()
    }
  }))

export class ErrorParamsDtoModelSelector extends QueryBuilder {
  get code() { return this.__attr(`code`) }
  get error() { return this.__attr(`error`) }
  details(builder: string | ErrorDetailsDtoModelSelector | ((selector: ErrorDetailsDtoModelSelector) => ErrorDetailsDtoModelSelector) | undefined) { return this.__child(`details`, ErrorDetailsDtoModelSelector, builder) }
}
export function selectFromErrorParamsDto() {
  return new ErrorParamsDtoModelSelector()
}

export const errorParamsDtoModelPrimitives = selectFromErrorParamsDto().code.error
